import React from "react";
import {
  Box,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import linkIcon from "assets/images/LinkSimple.svg";

function CommonLinkModel(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleClose = () => {
    props.handleClose();
  };

  const handleText = () => {
    navigator.clipboard.writeText(props?.shareTripUrl || "");
    toast.success("Copied Successfully");
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={props.open || false}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      className="p20"
    >
      <DialogContent className="w500">
        <Box className="justifyBetween">
          <Typography
            variant={"head3"}
            className="titleStyle fw700 colorPrimary"
          >
            Share Trip Link
          </Typography>
          <Box className="pl10">
            <IconButton
              aria-label="close"
              onClick={handleClose}
              className="modelCloseIcon"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <Grid container item md={12}>
          <TextField
            className="ml10 width100"
            placeholder="Share Link"
            inputProps={{ "aria-label": "Share Link" }}
            disabled={true}
            value={props?.shareTripUrl || ""}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" onClick={handleText}>
                  <IconButton>
                    <img src={linkIcon} alt="linkLogo" className="link" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default CommonLinkModel;
